/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPINCOMEOPTION } from './IAPINCOMEOPTION';
import {
    IAPINCOMEOPTIONFromJSON,
    IAPINCOMEOPTIONFromJSONTyped,
    IAPINCOMEOPTIONToJSON,
} from './IAPINCOMEOPTION';

/**
 * 
 * @export
 * @interface InvestmentDetailsFeesViewModel
 */
export interface InvestmentDetailsFeesViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsFeesViewModel
     */
    initialAdviceFeeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsFeesViewModel
     */
    initialAdviceFeePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsFeesViewModel
     */
    recurringAdviceFeeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsFeesViewModel
     */
    recurringAdviceFeePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsFeesViewModel
     */
    annualAdviceFeePercentage?: number;
    /**
     * 
     * @type {IAPINCOMEOPTION}
     * @memberof InvestmentDetailsFeesViewModel
     */
    initialAdviceFeeToggle: IAPINCOMEOPTION;
    /**
     * 
     * @type {IAPINCOMEOPTION}
     * @memberof InvestmentDetailsFeesViewModel
     */
    recurringAdviceFeeToggle: IAPINCOMEOPTION;
}

/**
 * Check if a given object implements the InvestmentDetailsFeesViewModel interface.
 */
export function instanceOfInvestmentDetailsFeesViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "initialAdviceFeeToggle" in value;
    isInstance = isInstance && "recurringAdviceFeeToggle" in value;

    return isInstance;
}

export function InvestmentDetailsFeesViewModelFromJSON(json: any): InvestmentDetailsFeesViewModel {
    return InvestmentDetailsFeesViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsFeesViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsFeesViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'initialAdviceFeeAmount': !exists(json, 'InitialAdviceFeeAmount') ? undefined : json['InitialAdviceFeeAmount'],
        'initialAdviceFeePercentage': !exists(json, 'InitialAdviceFeePercentage') ? undefined : json['InitialAdviceFeePercentage'],
        'recurringAdviceFeeAmount': !exists(json, 'RecurringAdviceFeeAmount') ? undefined : json['RecurringAdviceFeeAmount'],
        'recurringAdviceFeePercentage': !exists(json, 'RecurringAdviceFeePercentage') ? undefined : json['RecurringAdviceFeePercentage'],
        'annualAdviceFeePercentage': !exists(json, 'AnnualAdviceFeePercentage') ? undefined : json['AnnualAdviceFeePercentage'],
        'initialAdviceFeeToggle': IAPINCOMEOPTIONFromJSON(json['InitialAdviceFeeToggle']),
        'recurringAdviceFeeToggle': IAPINCOMEOPTIONFromJSON(json['RecurringAdviceFeeToggle']),
    };
}

export function InvestmentDetailsFeesViewModelToJSON(value?: InvestmentDetailsFeesViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InitialAdviceFeeAmount': value.initialAdviceFeeAmount,
        'InitialAdviceFeePercentage': value.initialAdviceFeePercentage,
        'RecurringAdviceFeeAmount': value.recurringAdviceFeeAmount,
        'RecurringAdviceFeePercentage': value.recurringAdviceFeePercentage,
        'AnnualAdviceFeePercentage': value.annualAdviceFeePercentage,
        'InitialAdviceFeeToggle': IAPINCOMEOPTIONToJSON(value.initialAdviceFeeToggle),
        'RecurringAdviceFeeToggle': IAPINCOMEOPTIONToJSON(value.recurringAdviceFeeToggle),
    };
}

